import { push } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import {
  ROUTE_PATH,
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
  APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
  APPLICATION_MODE_NEW,
} from "../../app/constants";
import { Button } from "../../components/RegularComponents";
import TopNavigationBar from "../TopNavigationBar";

export const IsNineteenQuestionView = (props) => {
  const dispatch = useDispatch();

  const agentApplication = useSelector(currentAgentApplicationSelector) || {};
  const licencingSubType = agentApplication?.licencingSubType ?? LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;
  const isPrincipalBroker = licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;

  const title =
    !isPrincipalBroker
      ? "Is the applicant at least 19 years old"
      : "Are you at least 19 years old?";

  const handleNext = (isOldEnough) => () => {
    const yesPath =
      !isPrincipalBroker
        ? ROUTE_PATH.MRA_ASSOCIATE_APPLICANT_INFO
        : ROUTE_PATH.MRA_APPLY_FOR_MORTGAGE_LICENCE;

    const nextPath = isOldEnough ? yesPath : ROUTE_PATH.MRA_IS_NINETEEN_NO;
    dispatch(push(`${ROUTE_PATH.MRA_APP}${nextPath}`));
  };

  return (
    <div className="container">
      <TopNavigationBar 
          {...props} 
          applicationType={APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE} 
          applicationMode={APPLICATION_MODE_NEW} 
      />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{title}</h1>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-3">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
        </div>
      </div>
    </div>
  );
};
